//@ts-nocheck
// src/components/dashboard/Sidebar.tsx
import React, { Fragment, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Transition } from "@headlessui/react";
import { Dialog } from "@headlessui/react";

import { useAppDispatch, useAppSelector } from "../app/hooks";
import { logoutUser } from "../features/auth/authSlice";
import { Toaster, toast } from "sonner";
import { RootState } from "../app/store";
import {
  BaseSettingIcon,
  CalenderIcon,
  CustomUserIcon,
  DocumentIcon,
  FlagIcon,
  FolderIcon,
  HomeIcon,
  LogoutIcon,
  ProfileSettingIcon,
  SettingIcon,
  SwitchBaseIcon,
  TeamIcon,
  UserRoleIcon,
  baseNameIcon,
} from "../components/icons/Icons";
import {
  ChartPieIcon,
  InboxIcon,
  ReportIcon,
  SquareCheckIcon,
  UsersIcon,
} from "../components/icons/Icons";
import { fetchDocument, fetchJobList } from "../features/job/jobSlices";
import { useSearch } from "../context/SearchContext";
import VerticalSidebar from "../components/dashboard/VerticalSidebar";
import { useSidebar } from "../context/SidebarContext";
import CustomMenuDropdown from "../components/common/CustomMenuDropdown";
import { UserDetails } from "../features/auth/authTypes";
import CreateJob from "../components/dashboard/CreateJob";

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

interface SidebarProps {
  userDetails: UserDetails;
}

const Sidebar: React.FC<SidebarProps> = ({ userDetails }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const [updatedPathname, setUpdatedPathname] = useState<string>("");
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [updateChannelName, setUpdateChannelName] = useState("");
  const [updateBaseLogo, setUpdateBaseLogo] = useState(null);
  const [updateProfileImage, setUpdateProfileImage] = useState("");
  const baseIdString =
    localStorage.getItem("UserBaseId") || localStorage.getItem("createBaseId");
  const baseId = baseIdString ? JSON.parse(baseIdString) : null;
  const baseDetailsData = useAppSelector(
    (state: RootState) => state.base.baseDetails,
  );
  const userBaseIdMain = userDetails?.id || userDetails;
  const [userData, setUserData] = useState<any>(null);
  const [userBaseData, setUserBaseData] = useState<any>(null);
  const [userId, setUserId] = useState<any>(null);
  const userDetailsFromRedux = useAppSelector(
    (state: any) => state?.base?.baseDetails,
  );
  const [jobsList, setJobsList] = useState<any>([]);
  const [userDetails1, setUserDetails1] = useState<any>(null);
  const bases = useAppSelector(
    (state: RootState) => state?.base?.data?.data?.bases,
  );
  const { setSearchTerm, searchTerm } = useSearch();
  const { verticleSidebar, setVerticleSidebar } = useSidebar();
  const [isHovered, setIsHovered] = useState(false);
  const { jobId } = useParams<{ jobId: string }>();
  const [showSetting, setShowSetting] = useState(false);
  const [jobStatus, setJobStatus] = useState("");

  useEffect(() => {
    if (bases && bases.length > 0) {
      const matchedBase = bases.find(
        (base: { id: number }) => base.id.toString() === baseId,
      );
      if (matchedBase) {
        setUserDetails1(matchedBase);
      }
    } else if (baseId) {
      setUserDetails1(baseId);
    } else {
      setUserDetails1(null);
    }
  }, [baseId, bases]);

  useEffect(() => {
    if (userDetails && userBaseIdMain) {
      let newPathname = location.pathname;

      if (newPathname === `/${userBaseIdMain}/job/${jobId}/dashboard`) {
        newPathname = "dashboard";
      } else if (newPathname.startsWith(`/${userBaseIdMain}/`)) {
        newPathname = newPathname.replace(`/${userBaseIdMain}/`, "");
      }
      setUpdatedPathname(newPathname);
    } else {
      setUpdatedPathname(location.pathname);
    }
  }, [userDetails, location.pathname]);

  const navigation = [
    {
      name: "Dashboard",
      to: `/${userBaseIdMain}/job/${jobId}/dashboard`,
      icon: HomeIcon,
      current:
        location.pathname === `/${userBaseIdMain}/job/${jobId}/dashboard`,
    },
    {
      name: "Applications",
      to: `/${userBaseIdMain}/job/${jobId}/application`,
      icon: DocumentIcon,
      current:
        location.pathname === `/${userBaseIdMain}/job/${jobId}/application`,
    },
    {
      name: "Inbox",
      to: `/${userBaseIdMain}/job/${jobId}/inbox`,
      icon: InboxIcon,
      current: location.pathname === `/${userBaseIdMain}/job/${jobId}/inbox`,
    },
    {
      name: "Task",
      to: `/${userBaseIdMain}/job/${jobId}/task`,
      icon: SquareCheckIcon,
      current: location.pathname === `/${userBaseIdMain}/job/${jobId}/task`,
    },
    {
      name: "Calender",
      to: `/${userBaseIdMain}/job/${jobId}/calender`,
      icon: CalenderIcon,
      current: location.pathname === `/${userBaseIdMain}/job/${jobId}/calender`,
    },
    {
      name: "Reports",
      to: `/${userBaseIdMain}/job/${jobId}/reports`,
      icon: ChartPieIcon,
      current: location.pathname === `/${userBaseIdMain}/job/${jobId}/reports`,
    },
    {
      name: "Candidates",
      to: `/${userBaseIdMain}/job/${jobId}/candidates`,
      icon: UsersIcon,
      current:
        location.pathname === `/${userBaseIdMain}/job/${jobId}/candidates`,
    },
    // { name: 'Job Posting', to: `/${userBaseIdMain}/jobs`, icon: ReportIcon, current: location.pathname === `/${userBaseIdMain}/jobs` },
  ];

  const handleSignOut = () => {
    const clearAllStorageData = () => {
      // Clear all localStorage
      localStorage.clear();

      // Specifically remove items related to authentication and persistence
      const keysToRemove = [
        "accessToken",
        "authToken",
        "persist:root",
        "_persist",
      ];

      keysToRemove.forEach((key) => localStorage.removeItem(key));

      // If you're using cookies for any auth data, clear them here
      // For example:
      // document.cookie.split(";").forEach(c => {
      //   document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
      // });
    };

    dispatch(logoutUser())
      .then((resultAction) => {
        if (logoutUser.fulfilled.match(resultAction)) {
          clearAllStorageData();
          toast.success("Successfully logged out!");

          // Use a slight delay to ensure storage clearing is complete
          setTimeout(() => {
            navigate("/login");
          }, 100);
        } else if (logoutUser.rejected.match(resultAction)) {
          const payload = resultAction.payload as {
            status?: number;
            message: string;
          };
          if (payload.status === 401) {
            clearAllStorageData();
            toast.error("Session expired. Please log in again.");

            setTimeout(() => {
              window.location.href = "/login";
            }, 100);
          } else {
            toast.error("Logout failed. Please try again.");
          }
        }
      })
      .catch((error) => {
        console.error("Logout action failed", error);
        toast.error("Logout action failed. Please try again.");
      });
  };

  // base details

  useEffect(() => {
    const userBaseDetailsString = localStorage.getItem("baseDetails");
    if (userBaseDetailsString) {
      try {
        const userBaseDetails = JSON.parse(userBaseDetailsString); // Declare the variable here
        setUserBaseData(userBaseDetails?.data);
      } catch (e) {
        console.error("Error parsing userDetails:", e);
      }
    }
  }, []);

  // user details
  useEffect(() => {
    const userDetailsString = localStorage.getItem("userDetails");
    if (userDetailsString) {
      try {
        userDetails = JSON.parse(userDetailsString);
        setUserData(userDetails);
      } catch (e) {
        console.error("Error parsing userDetails:", e);
      }
    }
  }, []);

  useEffect(() => {
    const storedUserDetails = JSON.parse(
      localStorage.getItem("userDetails") || "{}",
    );
    setUserId(storedUserDetails);
  }, []);

  const handleBaseNavigate = () => {
    navigate("/base");
  };

  const handleProfileSetting = () => {
    navigate(`/user/${userId?.id}/profile`);
  };

  const handleBaseSetting = () => {
    navigate(`/${userBaseIdMain}/settings/base/`);
  };

  // custom dropdown
  const profileMenuSections = [
    {
      options: [
        {
          icon: CustomUserIcon,
          label: userData?.name,
          onClick: () => console.log("Profile clicked"),
        },
        {
          icon: ProfileSettingIcon,
          label: "Profile Setting",
          onClick: handleProfileSetting,
        },
      ],
    },
    {
      options: [
        {
          icon: baseNameIcon,
          label: userBaseData?.base?.name || userDetailsFromRedux?.name,
          onClick: () => console.log("Profile clicked"),
        },
        {
          icon: UserRoleIcon,
          label: userData?.role || userBaseData?.base?.role,
          onClick: () => console.log("Profile clicked"),
        },
        // { icon: CogIcon, label: 'Base Setting', onClick: handleBaseSetting },
        ...(userData?.role === "admin"
          ? [
              {
                icon: BaseSettingIcon,
                label: "Base Setting",
                onClick: handleBaseSetting,
              },
            ]
          : []),
      ],
    },
    {
      options: [
        {
          icon: SwitchBaseIcon,
          label: "Create/Switch Base",
          onClick: handleBaseNavigate,
        },
      ],
    },
    {
      options: [
        { icon: LogoutIcon, label: "Sign out", onClick: handleSignOut },
      ],
    },
  ];

  // fetch base name
  useEffect(() => {
    // Retrieve and parse the stored channel data
    const storedData = localStorage.getItem("baseDetails");
    //  const baseData = baseDetailsData
    const finalData = storedData || baseDetailsData;

    if (finalData) {
      try {
        // const parsedData = JSON.parse(finalData);
        const parsedData =
          typeof finalData === "string" ? JSON.parse(finalData) : finalData;

        if (parsedData?.data?.base?.name) {
          setUpdateChannelName(parsedData?.data?.base?.name);
        } else if (finalData?.name) {
          setUpdateChannelName(parsedData?.name);
        }
      } catch (error) {
        console.error("Error parsing stored channel data:", error);
      }
    }
  }, []);

  // fetch base logo
  useEffect(() => {
    const storedData = localStorage.getItem("baseDetails");
    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData);

        if (parsedData && parsedData.data.base && parsedData.data.base.logo) {
          setUpdateBaseLogo(
            parsedData && parsedData.data.base && parsedData.data.base.logo,
          );
        }
      } catch (error) {
        console.error("Error parsing stored channel data:", error);
      }
    }
  }, [updateBaseLogo]);

  // fetch user image
  const imageUrl = updateProfileImage
    ? `${process.env.REACT_APP_API_BASE_URL}/${updateProfileImage}`
    : "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80";

  // fetch base logo
  useEffect(() => {
    const storedData = localStorage.getItem("userDetails");
    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData);
        if (parsedData && parsedData.profile_pic) {
          setUpdateProfileImage(parsedData && parsedData.profile_pic);
        }
      } catch (error) {
        console.error("Error parsing stored channel data:", error);
      }
    }
  }, [updateBaseLogo]);

  // job listing
  // useEffect(() => {
  //   if (baseId) {
  //     const fetchTeams = async () => {
  //       const storedBase = localStorage.getItem('baseJobListingData');

  //       if (storedBase) {
  //         const parsedBase = JSON.parse(storedBase);
  //         setJobsList(parsedBase.data.jobPost);
  //       } else {
  //         try {
  //           const baseResponse = await dispatch(fetchJobList({ baseId: userDetails1?.id || baseId }));
  //           if (baseResponse?.payload) {
  //             setJobsList(baseResponse?.payload.jobPost);
  //             localStorage.setItem('baseJobListingData', JSON.stringify(baseResponse?.payload));
  //           } else {
  //             console.warn("No data returned from API");
  //           }
  //         } catch (error) {
  //           console.error("Error fetching base member details:", error);
  //         }
  //       }
  //     };

  //     fetchTeams();
  //   }
  // }, [baseId, dispatch]);

  const handleTeamMemberDataSave = () => {};

  const [searchValue, setSearchValue] = useState("");

  const handleSearch = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent form submission
      setSearchTerm(searchValue);
    }
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  // Fixed hook usage
  useEffect(() => {
    if (searchTerm === "") {
      setSearchValue("");
    }
  }, [searchTerm]);

  const handleSideBar = () => {
    setVerticleSidebar(!verticleSidebar);
  };

  const handleSettingPage = () => {
    navigate(`/${userBaseIdMain}/job/${jobId}/manage/detail`);
  };

  // Check if the current URL matches the pattern
  useEffect(() => {
    if (location.pathname) {
      let newPathname =
        location.pathname.endsWith("application") ||
        location.pathname.endsWith("pipeline");
      if (newPathname) {
        setShowSetting(true);
      } else {
        setShowSetting(false);
      }

      // handleSettingPage();
    }
  }, [location.pathname, jobId]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (jobId && baseId) {
          const res = await dispatch(fetchDocument({ baseId, id: jobId }));
          if (res.payload) {
            setJobStatus(res.payload.data);
          }
        }
      } catch (error) {
        console.error("Error fetching document:", error);
      }
    };

    fetchData();
  }, [dispatch, jobId, baseId]);

  return (
    <div>
      {/* header */}
      <div
        className={`${verticleSidebar ? "lg:pl-[225px]" : "lg:pl-[59px]"} transition-all duration-300`}
      >
        <div
          className="fixed top-0 sidebar-fixed sm:w-full"
          style={{ zIndex: 9 }}
        >
          <div className="flex w-full h-[56px] shrink-0 items-center gap-x-4 bg-white px-4 shadow-custom-1 sm:gap-x-6 sm:px-6 lg:px-4">
            <button
              type="button"
              onClick={() => setSidebarOpen(true)}
              className="-m-2.5 p-2.5 text-gray-700 lg:hidden"
            >
              <span className="sr-only">Open sidebar</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="#0000007a"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="icon icon-tabler icons-tabler-outline icon-tabler-search  w-[1.2rem] h-[1.2rem] text-[#0000007a]"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
                <path d="M21 21l-6 -6" />
              </svg>
            </button>
            <div
              className="h-6 w-px bg-gray-900/10 lg:hidden"
              aria-hidden="true"
            />

            <div
              className="flex items-center justify-between"
              style={{
                width: verticleSidebar
                  ? "calc(100% - 225px)"
                  : "calc(100% - 59px)",
              }}
            >
              <h2 className="text-black-100 font-semibold text-sm capitalize">
                {!jobId && updatedPathname
                  ? updatedPathname
                  : jobStatus?.job_title}
              </h2>

              {/* {
                updatedPathname &&
                <h2 className="text-black-100 font-semibold text-sm capitalize">
                  {updatedPathname}
                </h2>
              } */}

              {/* {
                jobStatus && 
                <h2 className="text-black-100 font-semibold text-sm capitalize">
                {jobStatus?.job_title}
              </h2>
              } */}
              <div className="flex items-center gap-2">
                <div className="flex gap-x-4 self-stretch lg:gap-x-6 px-[0.75rem]">
                  {showSetting && (
                    <button onClick={handleSettingPage}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="icon icon-tabler icons-tabler-outline icon-tabler-settings w-[1rem] h-[1rem] text-[#808080]"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z" />
                        <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
                      </svg>
                    </button>
                  )}

                  <form
                    className="relative flex flex-1"
                    onSubmit={(e) => e.preventDefault()}
                  >
                    <label htmlFor="search-field" className="sr-only">
                      Search
                    </label>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                      data-slot="icon"
                      className="pointer-events-none absolute inset-y-0 left-1.5 h-full w-4 text-[#000000eb]"
                    >
                      <path
                        fillRule="evenodd"
                        d="M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <input
                      className="w-full h-[32px] border border-solid border-[#00000014] rounded-md pl-7 text-[0.8125rem] ring-0 focus:ring-[#2563eb] focus:ring-1 flex items-center justify-center"
                      placeholder="Search"
                      type="text"
                      value={searchValue}
                      onChange={handleSearchChange}
                      onKeyDown={handleSearch}
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* mobile sidebar */}
      <Transition.Root show={sidebarOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50 lg:hidden"
          onClose={setSidebarOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="transition-opacity ease-linear duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-linear duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-900/80" />
          </Transition.Child>

          <div className="fixed inset-0 flex">
            <Transition.Child
              as={Fragment}
              enter="transition ease-in-out duration-300 transform"
              enterFrom="-translate-x-full"
              enterTo="translate-x-0"
              leave="transition ease-in-out duration-300 transform"
              leaveFrom="translate-x-0"
              leaveTo="-translate-x-full"
            >
              <Dialog.Panel className="relative mr-16 flex w-full max-w-xs flex-1">
                <Transition.Child
                  as={Fragment}
                  enter="ease-in-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in-out duration-300"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="absolute left-[82%] top-[-14px] flex w-16 justify-center pt-5">
                    <button
                      type="button"
                      className="-m-2.5 p-2.5"
                      onClick={() => setSidebarOpen(false)}
                    >
                      <span className="sr-only">Close sidebar</span>
                    </button>
                  </div>
                </Transition.Child>
                <div className="flex grow flex-col gap-y-4 overflow-y-auto bg-light-pink px-6 pb-4 py-4">
                  <div className="flex shrink-0 items-center px-[0rem] justify-between">
                    <Link to={`#`}>
                      <div className="flex gap-[0.5rem] items-center cursor-pointer h-[32px] px-[0.25rem]">
                        <img
                          className="h-6 w-6 rounded-[5px]"
                          src={`https://pub-cc3cd436d40a477e89608a74e53ac0ec.r2.dev/uploads/logo/76592db3-5a50-4bec-9824-65c91ea060da.png`}
                          alt="base logo"
                        />
                        <span className="leading-[1.2] font-semibold whitespace-nowrap text-[0.8125rem] cursor-pointer capitalize">
                          M249
                        </span>
                      </div>
                    </Link>
                    <div className="flex items-center gap-x-4 lg:gap-x-6 w-[120px] relative z-50 [&>button]:hover:bg-transparent">
                      {/* Profile dropdown */}
                      {/* <MenuDropdown
                      groups={dropdownGroups}
                      image={ */}
                      <img
                        className="h-6 w-6 rounded-full bg-gray-50"
                        src={`https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80`}
                        alt=""
                      />
                      {/* } */}
                      {/* /> */}
                    </div>
                  </div>
                  <nav className="flex flex-1 flex-col">
                    <ul role="list" className="-mx-2 space-y-1">
                      {navigation.map((item) => (
                        <li key={item.name}>
                          <a
                            href={item.to}
                            className={classNames(
                              item.current
                                ? " text-black-100 bg-[#00000014] hover:bg-[rgb(0 0 0 / 6%)] cursor-pointer"
                                : "text-black-100 hover:text-black-100 hover:bg-gray-100 cursor-pointer",
                              "group flex gap-x-[10px] p-0 text-[13px]  m-0 min-h-[32px] w-full cursor-pointer leading-5 items-center rounded-[0.375rem] font-medium text-wedges-gray-900 focus:outline-none px-2",
                            )}
                          >
                            <item.icon
                              aria-hidden="true"
                              className={classNames(
                                item.current
                                  ? "text-[#808080]"
                                  : "text-red-100 group-hover:text-[#808080]",
                                "h-[1.1em] w-[1.1em] shrink-0",
                              )}
                            />
                            {item.name}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </nav>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>

      {/* Static sidebar for desktop */}

      <VerticalSidebar
        updateBaseLogo={updateBaseLogo}
        navigation={navigation}
        verticleSidebar={verticleSidebar}
        setVerticleSidebar={setVerticleSidebar}
      />

      {verticleSidebar && (
        <div
          className="hidden lg:fixed lg:inset-y-0 lg:z-[9] lg:flex lg:w-[225px] lg:flex-col"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <div className="flex grow flex-col bg-white pt-[0.75rem] px-0 pb-4 sidebar-des border-r border-gray-100">
            <div className="flex shrink-0 items-center px-[0.75rem] justify-between">
              <Link to={`/${baseId}/job/${jobId}/dashboard`}>
                <div className="flex gap-[0.5rem] items-center cursor-pointer h-[32px] px-[0.25rem]">
                  {updateBaseLogo === null ? (
                    <img
                      className="h-6 w-6 rounded-[5px]"
                      src="https://www.gravatar.com/avatar/2c7d99fe281ecd3bcd65ab915bac6dd5?s=250"
                    />
                  ) : (
                    <img
                      className="h-6 w-6 rounded-[5px]"
                      src={`${process.env.REACT_APP_API_BASE_URL}/${updateBaseLogo}`}
                      alt="base logo"
                    />
                  )}

                  <span
                    className="leading-[1.2] font-semibold whitespace-nowrap text-[0.8125rem] cursor-pointer truncate w-full max-w-[170px] min-w-[130px] overflow-hidden text-ellipsis
                 text-start capitalize "
                  >
                    {updateChannelName}
                  </span>
                </div>
              </Link>
              <div className="flex items-center gap-x-4 lg:gap-x-6 w-[350px] relative z-50 [&>button]:hover:bg-transparent justify-end">
                {/* Profile dropdown */}

                <CustomMenuDropdown
                  imageUrl={imageUrl}
                  altText="User profile"
                  sections={profileMenuSections}
                />
              </div>
            </div>

            <CreateJob />

            <nav className="flex flex-col px-[0.75rem]">
              <ul role="list" className="flex flex-1 flex-col gap-y-5">
                <li>
                  <ul role="list" className="">
                    {navigation.map((item) => {
                      const isActive = location.pathname === item.to; // Check if the current path matches the item's path
                      return (
                        <li
                          key={item.name}
                          className="h-[32px] first:mt-[1rem] mb-[2px] py-[2px] sidebar-nav"
                        >
                          <Link
                            to={item.to}
                            className={classNames(
                              isActive
                                ? "text-black-100 bg-gray-200 hover:bg-gray-300"
                                : "text-black-100 hover:text-black-100 hover:bg-gray-100",
                              "group flex gap-x-[10px] p-0 text-[13px] m-0 min-h-[32px] w-full cursor-pointer leading-5 items-center rounded-[0.375rem] font-medium text-wedges-gray-900 focus:outline-none px-2",
                            )}
                          >
                            <item.icon
                              aria-hidden="true"
                              className={classNames(
                                isActive
                                  ? "text-[#0000007a]"
                                  : "text-[#0000007a] group-hover:text-black-100",
                                "h-[1.1em] w-[1.1em] shrink-0",
                              )}
                            />
                            {item.name}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </li>
                <li className="">
                  <div className="flex Items-center justify-between	 px-[8px] text-black-100 hover:text-black-100 hover:bg-gray-100 h-[32px] rounded-[0.375rem] my-[2px]">
                    <Link
                      className="text-[13px] flex justify-start gap-x-2 items-center w-full font-[500] text-black-100 hover:text-black-100 mt-[-1px] capitalize"
                      to={`/${userBaseIdMain}/job/${jobId}/jobs`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="icon icon-tabler icons-tabler-outline icon-tabler-device-gamepad-3 w-[1rem] h-[1rem] text-[#808080]"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M9 12l-3 -3h-2a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h2z" />
                        <path d="M15 12l3 -3h2a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-2z" />
                        <path d="M12 15l-3 3v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1 -1v-2z" />
                        <path d="M12 9l-3 -3v-2a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v2z" />
                      </svg>
                      Job openings
                      {/* 
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#0000007a"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="icon icon-tabler icons-tabler-outline icon-tabler-plus  w-[1rem] h-[1rem] text-[#0000007a]"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M12 5l0 14" />
                        <path d="M5 12l14 0" />
                      </svg> */}
                    </Link>
                  </div>
                  {/* <ul role="list" className="max-h-[310px] overflow-y-auto mx-[-0.75rem]">
                  {jobsList?.map((team: { name: string; to: string; icon: JSX.Element }) => {
                    const isActive =
                      location.pathname === `job/${team?.id}/manage/detail`;
                    return (
                      <li key={team?.id} className="h-[32px] first:mt-[0.4rem] mb-[2px] py-[2px] mx-[0.75rem]"
                        onClick={() => handleTeamMemberDataSave(team?.id)}
                      >
                        <Link
                          to={`/${baseId}/job/${team?.id}/manage/detail`}
                          className={classNames(
                            isActive
                              ? 'text-black-100 bg-gray-200 hover:bg-gray-300'
                              : 'text-black-100 hover:text-black-100 hover:bg-gray-100',
                            'group flex gap-x-[10px] p-0 text-[13px] m-0 min-h-[32px] capitalize w-full cursor-pointer leading-5 items-center rounded-[0.375rem] font-medium text-wedges-gray-900 focus:outline-none px-2'
                          )}
                        >
                          <span
                            className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-[2px] border-none text-[0.625rem] font-medium text-white capitalize"
                            style={{ backgroundColor: '#3b82f6' }}
                          />
                          {team?.job_title}
                        </Link>
                      </li>
                    );
                  })}
                </ul> */}

                  <ul
                    role="list"
                    className="max-h-[310px] overflow-x-auto mx-[-0.75rem]"
                  >
                    <li className="h-[32px] first:mt-[0.4rem] mb-[2px] py-[2px] mx-[0.75rem]">
                      <a
                        className="text-black-100 hover:text-black-100 hover:bg-gray-100 group flex gap-x-[10px] p-0 text-[13px] m-0 min-h-[32px] w-full cursor-pointer leading-5 items-center rounded-[0.375rem] font-medium text-wedges-gray-900 focus:outline-none px-2"
                        href=""
                      >
                        <div className="flex items-center gap-x-[10px]">
                          <span
                            className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-[2px] border-none text-[0.625rem] font-medium text-white capitalize"
                            style={{ backgroundColor: "rgb(107, 114, 128)" }}
                          />
                          <span className="truncate text-[13px] leading-4 whitespace-nowrap w-[140px] overflow-hidden text-ellipsis text-start">
                            Create Channel
                          </span>
                        </div>
                        <div className=" whitespace-normal pr-[6px] text-[0.75rem] text-[#1d2025] uppercase opacity-60 font-[500]">
                          20
                        </div>
                      </a>
                    </li>
                    <li className="h-[32px] first:mt-[0.4rem] mb-[2px] py-[2px] mx-[0.75rem]">
                      <a
                        className="text-black-100 hover:text-black-100 hover:bg-gray-100 group flex gap-x-[10px] p-0 text-[13px] m-0 min-h-[32px] w-full cursor-pointer leading-5 items-center rounded-[0.375rem] font-medium text-wedges-gray-900 focus:outline-none px-2"
                        href=""
                      >
                        <div className="flex items-center gap-x-[10px]">
                          <span
                            className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-[2px] border-none text-[0.625rem] font-medium text-white capitalize"
                            style={{ backgroundColor: "rgb(34, 197, 94)" }}
                          />
                          <span className="truncate text-[13px] leading-4 whitespace-nowrap w-[140px] overflow-hidden text-ellipsis text-start">
                            Testing
                          </span>
                        </div>
                        <div className=" whitespace-normal pr-[6px] text-[0.75rem] text-[#1d2025] uppercase opacity-60 font-[500]">
                          20
                        </div>
                      </a>
                    </li>
                    <li className="h-[32px] first:mt-[0.4rem] mb-[2px] py-[2px] mx-[0.75rem]">
                      <a
                        className="text-black-100 hover:text-black-100 hover:bg-gray-100 group flex gap-x-[10px] p-0 text-[13px] m-0 min-h-[32px] w-full cursor-pointer leading-5 items-center rounded-[0.375rem] font-medium text-wedges-gray-900 focus:outline-none px-2"
                        href=""
                      >
                        <div className="flex items-center gap-x-[10px]">
                          <span
                            className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-[2px] border-none text-[0.625rem] font-medium text-white capitalize"
                            style={{ backgroundColor: "rgb(234, 179, 8)" }}
                          />
                          <span className="truncate text-[13px] leading-4 whitespace-nowrap w-[140px] overflow-hidden text-ellipsis text-start">
                            mission internet
                          </span>
                        </div>
                        <div className=" whitespace-normal pr-[6px] text-[0.75rem] text-[#1d2025] uppercase opacity-60 font-[500]">
                          20
                        </div>
                      </a>
                    </li>
                    <li className="h-[32px] first:mt-[0.4rem] mb-[2px] py-[2px] mx-[0.75rem]">
                      <a
                        className="text-black-100 hover:text-black-100 hover:bg-gray-100 group flex gap-x-[10px] p-0 text-[13px] m-0 min-h-[32px] w-full cursor-pointer leading-5 items-center rounded-[0.375rem] font-medium text-wedges-gray-900 focus:outline-none px-2"
                        href=""
                      >
                        <div className="flex items-center gap-x-[10px]">
                          <span
                            className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-[2px] border-none text-[0.625rem] font-medium text-white capitalize"
                            style={{ backgroundColor: "rgb(107, 114, 128)" }}
                          />
                          <span className="truncate text-[13px] leading-4 whitespace-nowrap w-[140px] overflow-hidden text-ellipsis text-start"></span>
                        </div>
                        <div className=" whitespace-normal pr-[6px] text-[0.75rem] text-[#1d2025] uppercase opacity-60 font-[500]">
                          20
                        </div>
                      </a>
                    </li>
                    <li className="h-[32px] first:mt-[0.4rem] mb-[2px] py-[2px] mx-[0.75rem]">
                      <a
                        className="text-black-100 hover:text-black-100 hover:bg-gray-100 group flex gap-x-[10px] p-0 text-[13px] m-0 min-h-[32px] w-full cursor-pointer leading-5 items-center rounded-[0.375rem] font-medium text-wedges-gray-900 focus:outline-none px-2"
                        href=""
                      >
                        <div className="flex items-center gap-x-[10px]">
                          <span
                            className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-[2px] border-none text-[0.625rem] font-medium text-white capitalize"
                            style={{ backgroundColor: "rgb(107, 114, 128)" }}
                          />
                          <span className="truncate text-[13px] leading-4 whitespace-nowrap w-[140px] overflow-hidden text-ellipsis text-start">
                            mission mars
                          </span>
                        </div>
                        <div className=" whitespace-normal pr-[6px] text-[0.75rem] text-[#1d2025] uppercase opacity-60 font-[500]">
                          20
                        </div>
                      </a>
                    </li>
                    <li className="h-[32px] first:mt-[0.4rem] mb-[2px] py-[2px] mx-[0.75rem]">
                      <a
                        className="text-black-100 hover:text-black-100 hover:bg-gray-100 group flex gap-x-[10px] p-0 text-[13px] m-0 min-h-[32px] w-full cursor-pointer leading-5 items-center rounded-[0.375rem] font-medium text-wedges-gray-900 focus:outline-none px-2"
                        href=""
                      >
                        <div className="flex items-center gap-x-[10px]">
                          <span
                            className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-[2px] border-none text-[0.625rem] font-medium text-white capitalize"
                            style={{ backgroundColor: "rgb(107, 114, 128)" }}
                          />
                          <span className="truncate text-[13px] leading-4 whitespace-nowrap w-[140px] overflow-hidden text-ellipsis text-start"></span>
                        </div>
                        <div className=" whitespace-normal pr-[6px] text-[0.75rem] text-[#1d2025] uppercase opacity-60 font-[500]">
                          20
                        </div>
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </nav>

            <li className="list-none px-[12px] sidebar-nav mt-auto">
              {userData?.role === "admin" && (
                <Link
                  to={`/${userBaseIdMain}/settings/base/`} // Adjust the path here to point to the correct settings route
                  className="group flex gap-x-[10px] p-0 text-[13px] m-0 min-h-[32px] w-full cursor-pointer leading-5 items-center rounded-[0.375rem] font-medium text-wedges-gray-900 focus:outline-none px-2"
                >
                  <SettingIcon
                    className="h-[1.1em] w-[1.1em] shrink-0 text-[#0000007a] group-hover:text-black-100"
                    aria-hidden="true"
                  />
                  Settings
                </Link>
              )}
            </li>
            <li className="list-none px-[12px] sidebar-nav flex items-center justify-between">
              <Link
                to="#"
                // onClick={haShare feedbackndleClickSetting}
                className="group flex gap-x-[10px] p-0 text-[13px] m-0 min-h-[32px] w-full cursor-pointer leading-5 items-center rounded-[0.375rem] font-medium text-wedges-gray-900 focus:outline-none px-2"
              >
                <FlagIcon className="h-[1.1em] w-[1.1em] shrink-0 text-[#0000007a] group-hover:text-black-100" />
                Share feedback
              </Link>
              {isHovered && (
                <button onClick={handleSideBar}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="icon icon-tabler icons-tabler-outline icon-tabler-layout-sidebar-right-expand w-[1rem] h-[1rem] text-[#808080]"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" />
                    <path d="M15 4v16" />
                    <path d="M10 10l-2 2l2 2" />
                  </svg>
                </button>
              )}
            </li>
          </div>
        </div>
      )}
    </div>
  );
};

export default Sidebar;
